import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import Icon from '@hotmart/space-lib/dist/components/icon';
import { SliderArrow, SliderSettings } from 'src/components/slider';

export const sliderSettings: SliderSettings = {
  slidesToShow: 1,
  slidesPerRow: 2,
  arrows: true,
  infinite: false,
  touchMove: true,
  centerMode: true,
  centerPadding: '20px',
  nextArrow: (
    <SliderArrow>
      <Icon icon={faArrowRight} />
    </SliderArrow>
  ),
  prevArrow: (
    <SliderArrow>
      <Icon icon={faArrowLeft} />
    </SliderArrow>
  )
};
